export const templateHtml = `<body>

  <contract-header>
    <!-- Company name and logo, date, etc. -->
        <!-- Available template literals:
        COMPANY_NAME
        COMPANY_LOGO
        CREATION_DATE
        CONTRACT_NAME
        CONTRACT_CODE
        -->
  </contract-header>

  <customer-info>
    <!-- Name, address, contact details. -->
      <!-- Available template literals:
        CUSTOMER_FIRST_NAME
        CUSTOMER_LAST_NAME
        CUSTOMER_EMAIL
        CUSTOMER_PHONE
        CUSTOMER_STREET
        CUSTOMER_ZIP_CODE
        CUSTOMER_CITY
        -->
  </customer-info>

  <dealer-info>
    <!-- Name, address, contact details. -->
      <!-- Available template literals:
        DEALER_VAT_NUMBER
        DEALER_COMPANY_NO
        DEALER_NO
        DEALER_ADDRESS
        DEALER_ZIP_CODE
        DEALER_CITY
        -->
  </dealer-info>

  <product-list>
    <!-- A single product row. Based on number of actual times, the table will be dynamically generated. -->
      <!-- Available template literals:
        PRODUCT_QTY
        PRODUCT_NAME
        PRODUCT_SERIAL_NO
        PRODUCT_INSURANCE
        PRODUCT_SERVICE
        PRODUCT_RESIDUAL
        PRODUCT_MONTHLY_FEE
        PRODUCT_TOTAL_PRICE
        -->
  </product-list>

  <total-value>
    <!-- Display total contract value and breakdown. -->
       <!-- Available template literals:
        TOTAL_LENGTH
        TOTAL_MONTHLY_FEE
        TOTAL_TOTAL
        -->
  </total-value>

  <contract-terms>
    <!-- Legal terms, duration, clauses. -->
       <!-- Available template literals:
        TERMS_DISCLAIMER
        -->
  </contract-terms>

</body>`
